import React, { useState, useEffect ,useContext, useCallback} from "react";
import {Form,Input,Select,Space,Row,Col,Button,Modal,Table, message,Popconfirm} from "antd";
import "../../Styles/subtenant.css";
import Services from "../../network/Services";
import konsole from "../../network/konsole";
import AddSubtenantUsers from "../SubtenantUsers/AddSubtenantUsers";
import DeleteConfirmModal from "../DeleteConfirmModal";
import { UserContext } from "../../App";
import { isNullUndefine } from "../../control/Constant";
import moment from "moment";

const { Option } = Select;
const { Search } = Input;

const CommonTable = (props) => {
  const [data, setdata] = useState([]);
  const [visible, setVisible] = useState(false);
  const [file, setFile] = useState("");
  const [subtenantValue, setSubtenantValue] = useState('');
  const [subtenantdata, setsubtenantdata] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);
  const [value, setValue] = useState("");
  const [assignOptionsList, setAssignOptionsList] = useState([]);
  const [show, setshow] = useState(false)
  const [showRolesModal, setShowRolesModal] = useState(false)
  const [selectedSubtenant, setselectedSubtenant] = useState('')
  const [selectedSubtenantUser, setSelectedSubtenantUser] = useState(null);
  const { setLoader } = useContext(UserContext)
  const [roleid, setroleid] = useState('')
  const [defaultvalue,setDefaultvalue]=useState('Select a partner')
  const [disabledselect,setdisableselect]=useState(false)
  const [searchevent, setSearchevent] =useState("");
  const [placement, SetPlacement] = useState("topLeft");
  const [deleteModal , setDeleteModal] = useState(false)
  const [showDeleteModal , setShowDeleteModal] = useState(false)
  const [userDataToDelete , setUserDataToDelete] = useState()
  const [updatePartnerUsersData , setUpdatePartnerUsersData] = useState()
  const [actionModalVisible, setActionModalVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [pageNumber,setPagenumber] = useState(1)

  const showUserModal = () => {
    setUpdatePartnerUsersData()
    setVisible(true);
    setshow(!show);
  };


  const formatPhoneNumber = (mobileNumber) => {
    const contactNumber = mobileNumber;
    function formatPhoneNumber(str) {
      let cleaned = ("" + str).replace(/\D/g, "");

      if (cleaned?.startsWith("254")) {
        return ` ${cleaned?.slice(3, 6) + " " + cleaned?.slice(6, 9) + " " + cleaned?.slice(9)}`
      }
      else {
        let contactNumber = cleaned?.slice(-10)
        let match = contactNumber?.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          return "(" + match[1] + ") " + match[2] + "-" + match[3];
        }
        return null;
      }
    }
    if (contactNumber) {
      if (contactNumber?.slice(0, 3) == +91) {
        return contactNumber?.slice(0, 3) + formatPhoneNumber(contactNumber)
      }
      else if (contactNumber?.slice(0, 4) == +254) {
        return contactNumber?.slice(0, 4) + formatPhoneNumber(contactNumber)
      }
      else {
        return contactNumber?.slice(0, 2) + formatPhoneNumber(contactNumber)
      }
    }
    else {
      return ""
    }
  }

  const getFormattedDateForCE = (value)=> {
    return moment(value).format('MM/DD/YYYY');
  }


  const showRolesModalFunc = (record) => {
    setSelectedSubtenantUser(record);
    setShowRolesModal(true);
  };

  const hideRolesModalFunc = () => {
    setShowRolesModal(false);
  };

  const hideUserModal = () => {
    setVisible(false);
    setshow(false)
  };

  const onFinish = (values) => {
    konsole.log("Finish:", values);
  };




  const onSelect = (e, key) => {
    setDefaultvalue(e);
    setSubtenantValue(key.key);
    setselectedSubtenant(e)
  };


  useEffect(() => {
    getUserListApi(1);
  }, [subtenantValue]);

  // console.log("subtenantdatasubtenantdata",subtenantdata)


  useEffect(()=>{
    let userroleId=JSON.parse(sessionStorage.getItem("stateObj"))
    let subtenantId=sessionStorage.getItem("subtenantId")
    setroleid(userroleId?.roleId)
    if(subtenantdata !=='' && subtenantdata !==undefined && roleid == "11"){
      setdisableselect(true)
      setSubtenantValue(subtenantId);
      setselectedSubtenant(subtenantId)
      let datafilter=subtenantdata.filter((val)=>{
        return val.subtenantId==subtenantId
      })
      setDefaultvalue(datafilter[0]?.subtenantName)
      setselectedSubtenant(datafilter[0]?.subtenantName)

    }else{
      setDefaultvalue(subtenantdata[0]?.subtenantName)

      setSubtenantValue(subtenantdata[0]?.subtenantId);
      setselectedSubtenant(subtenantdata[0]?.subtenantName)
      setdisableselect(false)
    }

  },[subtenantdata])



  const createdBy = null;
  const isActive = true;

  useEffect(() => {
    const Subtenantdetailspromise = Services.getsubtenantdetails(
      createdBy,
      isActive
    );
    Subtenantdetailspromise.then((res) => {
      setsubtenantdata(res.data.data);
    }).catch((err) => {
      konsole.log("err", err);
    });
  }, []);

  const getUserListApi = (pageNumber,serachText) => {
    // if(startValue !== 1){
      setLoader(true)
    // }
    const subtenantId = subtenantValue;
    if(subtenantId !=='' && subtenantId !== undefined && subtenantId !==null){


    const getUserlistpromise = Services.getUserAuthSubs(subtenantId,pageNumber,serachText);
    getUserlistpromise
      .then((res) => {
        // console.log("ressssressss", res.data.data);
        setdata(res.data.data);
        konsole.log(res.data.data)
        setAssignOptionsList(prev=>[...prev,...res.data.data]);
        setLoader(false)
        // if(startValue !== 1){

          hideUserModal()
        // }
        // if(startValue == EndValue - 1){

          hideRolesModalFunc()
        // }
      })
      .catch((err) => {
        konsole.log("errerr", err);
        setdata([])
        setAssignOptionsList([])
        hideUserModal()
        hideRolesModalFunc()
        setTableData([])
      }).finally(()=>{
        setLoader(false);
      });
    }
  };

  const scrollCallBack = (e) => {
    const node = e.target;

    if (node) {
      const { scrollTop, scrollHeight, clientHeight } = node;
      const scrollScreen = scrollTop + clientHeight;

      if (Math.ceil(scrollScreen) >= scrollHeight && previewIndex == 0) {
        setPagenumber(prev => prev+1)
        getUserListApi(pageNumber+1)
        // Perform other actions (e.g., load more content)
      }
    }
  };



  const searchonchange=useCallback(()=>{
    // let filteredData = [];
    if(searchevent !==null && searchevent !==undefined){
    getUserListApi(1,searchevent)
    }
    // return filteredData
  },[searchevent])

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      searchonchange()
    }
  };

  useEffect(()=>{
    if(deleteModal == true){
      CallDeleteAPi()
    }

  },[deleteModal])

  const CallDeleteAPi = () =>{
    setLoader(true)

     let detetedBy = sessionStorage.getItem('loggedUserId')
    let promise = Services.deletePartnerUserDetails(userDataToDelete?.userId, userDataToDelete?.userRgstrtnId, detetedBy)
    promise.then((response)=>{
      message.success("User Deleted Successfully")
      setShowDeleteModal(false)
      setDeleteModal(false)
      getUserListApi(1)
    }).catch((error)=>{
    }).finally(()=>{
    })
  }

  const headers = ["Service Plan","Client Name","Total Amount","Total Paid","Agreements","Action"];
  const table1Res = ["servicePlanName","clientName","totalAmount","paidAmount","userAuthSubs.length"];
  const table1Res2 = ["subscriptionName","totalOccurrence","installmentAmount","authSubsStartDate","totalAmount","totalDiscount","totalPayment","paymentTypeName","authLength"];
  const headers2 = ["Subscription Name","No of Instalments","Instalment Amount","Start Date","Total Amount","Discount","Total Paid","Mode of Payment","Installment Frequencies"];
  const headers3 = ["Amount","Pay Date","Status","Notes"];
  const table1Re3 = ["payAmount","payAmountDate","Status","notes"];

  const [header, setheader] = useState(headers)
  const [mapTable, setMapTable] = useState(table1Res)
  const [tableData, setTableData] = useState()
  const [previewIndex, setpreviewIndex] = useState(0)
  const [previesData, setPreviesData] = useState()
  const [newtableData, setNewtableData] = useState()

  konsole.log(tableData,"ssksksmxk", mapTable)

  useEffect(() => {
    if(!isNullUndefine(data)){
      setTableData(data)
    }
  }, [data])



  const handleChange = (json,isIncrease,index)=>{

    let indexes = 0;
    if(isIncrease == "yes"){
      indexes = previewIndex + 1
    }else if(previewIndex !== 0 && isIncrease == "no"){
      indexes = previewIndex - 1
    }
    if(indexes < 3)setpreviewIndex(indexes);

    if(indexes == 0){
      setheader(headers)
      setMapTable(table1Res)
      setTableData(data)
    }else if(indexes == 1){
      if (json && Object.keys(json).length > 0) {
        setNewtableData(json)
      }
      if(previewIndex == 2){
        setTableData(previesData)
      }else{
        setPreviesData(json?.userAuthSubs)
        setTableData(json?.userAuthSubs)
      }
      setheader(headers2)
      setMapTable(table1Res2)
      // console.log(json?.userAuthSubs,"jsonjsonjsonjson",headers2,"headers2",table1Res2,"previesData",previesData,"indexes",indexes)
    }else if(indexes == 2){
      newtableData["index"] = index
      setNewtableData(newtableData)
      setheader(headers3)
      setMapTable(table1Re3)

      const {authSubsInstallments,totalOccurrence} = json
      let totalInstalment = totalOccurrence - authSubsInstallments.length
      let newData = json?.authSubsInstallments
      let jsonData = {
        "createdBy": null,
        "updatedBy": null,
        "createdOn": "0001-01-01T00:00:00",
        "updatedOn": "0001-01-01T00:00:00",
        "authSubInstallmentId": 0,
        "orderId": 0,
        "payAmount": null,
        "payAmountDate": null,
        "notes": null,
        "isActive": null,
        "Status":'Paid'
    }

      if(totalOccurrence == 9999){
        Array().fill().forEach(() => newData.push({ ...jsonData }));
        newData = newData.map((e)=>{return {...e,Status:'Paid'}})
        setTableData(newData)
        // console.log(newData,"newDatanewData",totalInstalment)
        return;
      }

      if(totalInstalment !== 0 && totalInstalment < 9999){
        Array(totalInstalment).fill().forEach(() => newData.push({ ...jsonData }));
      }
      let payAmountHave = newData.filter((e)=>{return e.payAmount == json.installmentAmount})?.map((e)=>{return {...e,Status:'Paid'}})
      let startDate = new Date(json.authSubsStartDate);

      let payAmountNothave = newData.filter((e)=>{return e.payAmount != json.installmentAmount})?.map((e,i)=>{return{...e,payAmount:json.installmentAmount,Status:e?.paymentType == 1 &&  typeof e?.authSubInstallmentId == 'number' && Number?.isInteger(e?.authSubInstallmentId) ? '' : "Scheduled",payAmountDate: new Date(startDate.getTime() + (json.authLength * (i + 1)) * 24 * 60 * 60 * 1000)}})
      let payAmountNotzero = newData.filter((e)=>{return e.payAmount != null})?.map((e)=>{return {...e,Status:'Paid'}})
      setTableData([...payAmountNotzero,...payAmountHave,...payAmountNothave])
    }
  }

function getValueFromKey(row, key) {
    // If key itself is a number (i.e., phone number), format and return it
    if (key == "clientPhone") {
      return formatPhoneNumber(row[key]);
    }
    if (["authSubsStartDate","payAmountDate"].includes(key)) {
      return getFormattedDateForCE(row[key]) ?? "-";
    }
    if (["authLength"].includes(key)) {
      return getTimePeriodLabel(row[key]);
    }

    // If key ends with ".length", return the length of the base property
    if (key.endsWith(".length")) {
      const baseKey = key.split(".")[0];
      return row[baseKey]?.length ?? 0;
    }

    // Otherwise, resolve nested property
    return key.split(".").reduce((acc, part) => acc?.[part], row) ?? "-";
  }

  const sharedStyle = {
    border: "1px solid rgb(222, 226, 230)",
    borderRadius: "5px",
    backgroundColor: "rgb(222, 226, 230)"
  }

  const currentSub = !isNullUndefine(newtableData) ? newtableData?.userAuthSubs[newtableData?.index] : [];

  // let paidAmount = currentSub?.userAuthSubs?.reduce(
  //                   (total, subscription) =>
  //                     total + (subscription.authSubsInstallments?.reduce(
  //                       (installmentTotal, installment) => installmentTotal + (installment.payAmount || 0),
  //                       0
  //                     ) || 0),
  //                   0
  //                 ).toFixed(2)

  let totalPayment = currentSub?.authSubsInstallments?.reduce((acc, curr) => acc + Number(curr?.payAmount || 0), 0)
  // console.log(newtableData,"newtableData",currentSub?.totalDiscount)
  const sharedFields = {
    left: [
      { label: "Client Name", value: newtableData?.clientName },
      { label: "Client Email", value: newtableData?.clientEmail }
    ],
    left2: [
      { label: "Client Name", value: newtableData?.clientName },
      { label: "Agreement", value: currentSub?.subscriptionName },
      {label:"Discount",value: `$${currentSub?.totalDiscount == undefined || currentSub?.totalDiscount == null ? 0 : currentSub?.totalDiscount}`},
      { label: "Instalment Amount", value: `$${currentSub?.installmentAmount || 0}` }
      // { label: "Client Email", value: newtableData?.clientEmail }
    ],
    middle: [
      { label: "Total Amount", value: `$${currentSub?.totalAmount || 0}` },
      { label: "Status", value: currentSub?.isActive ? "Active" : "Not Active" },
      { label: "No of Instalments", value: currentSub?.totalOccurrence == 9999 ? 'Annualy' : currentSub?.totalOccurrence },
    ],
    right: [
      {label: "Mat No", value: newtableData?.matNo || "-"},
      // { label: "Client Phone", value: formatPhoneNumber(newtableData?.clientPhone)},
      { label: "Client Phone", value: formatPhoneNumber(newtableData?.clientPhone)},
    ],
    right2: [
      { label: "Service Plan", value: newtableData?.servicePlanName },
      { label: "Total Paid", value: `$${totalPayment}` },
      { label: "No of Instalments", value: currentSub?.totalOccurrence == 9999 ? 'Annually' : currentSub?.totalOccurrence },
      { label: "Status", value: currentSub?.isActive ? "Active" : "Not Active" },
    ],
    table2right: [
      { label: "Service Plan", value: newtableData?.servicePlanName },
      // { label: "Client Phone", value: formatPhoneNumber(newtableData?.clientPhone)},
      // {label: "Service Plan", value: newtableData?.matNo}
    ],
    middle2:[
      {label: "Mat No", value: newtableData?.matNo},
      { label: "Total Amount", value: `$${currentSub?.totalAmount || 0}` },
      { label: "Start Date", value: getFormattedDateForCE(currentSub?.authSubsStartDate) },
      { label: "Plan", value: getTimePeriodLabel(currentSub?.authLength) },


    ]
    // installments: [
    //   { label: "No of instalments", value: currentSub?.totalOccurrence },
    //   { label: "Instalment Amount", value: currentSub?.totalAmount }
    // ]
  };

  const renderPreviewSection = () => {
    if (previewIndex === 1) {
      return (
        <div>
          <div style={sharedStyle} className="p-3 mt-2 mb-2">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={8}>
                <div className="d-flex justify-content-center justify-content-md-end">
                  <Row gutter={[5, 5]}>{renderFields(sharedFields.left)}</Row>
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div className="d-flex justify-content-center justify-content-md-end">
                  <Row gutter={[5, 5]}>{renderFields(sharedFields.right)}</Row>
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div className="d-flex justify-content-center justify-content-md-end">
                  <Row gutter={[5, 5]}>{renderFields(sharedFields.table2right)}</Row>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      );
    }

    if (previewIndex === 2) {
      return (
        <div>
          <div style={sharedStyle} className="p-3 mt-2 mb-2">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={9}>
                <div className="d-flex justify-content-center justify-content-md-end">
                  <Row gutter={[5, 5]}>{renderFields(sharedFields.left2)}</Row>
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div className="d-flex justify-content-center justify-content-md-end">
                  <Row gutter={[5, 5]}>{renderFields(sharedFields.middle2)}</Row>
                </div>
              </Col>
              <Col xs={24} md={6}>
                <div className="d-flex justify-content-center justify-content-md-end">
                  <Row gutter={[5, 5]}>{renderFields(sharedFields.right2)}</Row>
                </div>
              </Col>
              {/* <Col xs={24} md={8}>
                <div className="d-flex justify-content-center justify-content-md-end">
                  <Row gutter={[8, 8]}>{renderFields(sharedFields.installments)}</Row>
                </div>
              </Col> */}
            </Row>
          </div>
        </div>
      );
    }

    return null;
  };

  const renderFields = (fields, colSize = 24) =>
    fields.map(({ label, value }) => (
      <Col key={label} className="mt-auto mb-auto" style={sharedStyle} xs={colSize} lg={colSize}>
        {label}: {value ?? "-"}
      </Col>
    ));

    function getTimePeriodLabel(days) {
      if (days == 7) {
        return "Weekly";
      } else if (days == 30) {
        return "Monthly";
      } else if (days == 365) {
        return "Yearly";
      } else {
        return `${days} days`;
      }
    }

const showActionModal = (record) => {
  setCurrentRecord(record);
  setActionModalVisible(true);
};

const hideActionModal = () => {
  setActionModalVisible(false);
  setCurrentRecord(null);
};


return (
    <div className="d-flex flex-column w-100 h-100">
      <Form.Provider  onFormFinish={(name, { values, forms }) => {if (name === "userForm") {const { basicForm } = forms;setVisible(false)}}} className="me-4">
        <Form name="basicForm" onFinish={onFinish}>
          <Row className="mt-2">
            <Col xs={24} lg={24} span={24} style={{ display: "flex", justifyContent: "space-between" }}>
              <Col span={12} style={{ display: "flex", alignItems:'center' }}>
                {previewIndex > 0 ?<Col className="d-flex align-items-center gap-2">
                  <Button htmlType="button" style={{backgroundColor: "#720c20", color: "white", fontWeight: "600", borderRadius:'50%', padding:'0px'}} onClick={() => handleChange("", "no")}>
                    <img className="p-0 m-2 ms-3" width="15px" height="15px" src="icons/backArrow2.svg" />
                  </Button>{previewIndex == 1 ? <h4 className="fw-bold mb-0">All Agreement Details</h4> : <h4 className="fw-bold mb-0">Payment Plan Details</h4>}
                </Col>: <div className="w-100 d-flex" style={{ border: "2px solid lightgray", justifyContent: "space-between", height: "39px", borderRadius:"2px" }}>
                  <input className="form-control fs-20" style={{ border: "none" }} type="text" placeholder={`${(roleid == 4) ? 'Search for firm user' : 'Search for staff member by name and email address'}`}
                    onChange={(e) => setSearchevent(e.target.value.toLowerCase())} />
                  <button style={{background:'transparent',border:'none'}} onClick={()=>searchonchange()} onKeyDown={(e)=>{handleKeyDown(e)}}>
                  <img style={{ padding: "2px", height: "20px", marginRight: "4px", cursor:'pointer' }} src="/search icon.png" />
                  </button>
                </div>}
              </Col>
            </Col>
          </Row>
          </Form>
        {renderPreviewSection()}
      </Form.Provider>

      <div className="table-wrapper mt-2 me-1 pb-3 w-100 h-100" style={{ maxHeight: "calc(100vh - 160px)",overflow:'auto'}} onScroll={scrollCallBack}>
        {JSON.stringify(mapTable) === JSON.stringify(table1Res) && (<h5 className="m-2 mt-1 mb-2" style={{ fontSize: '14px' }}>Here are all the agreements that have been made for the client.</h5>)}
        <table className="table mb-0 border" style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0 }}>
          <thead style={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1}}>
            <tr>
              {header.map((header, index) => (
                <th key={index} className='fw-bold p-2 text-center shadow-sm'>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData?.length > 0 ? tableData?.map((row, index) => (
              <tr key={index} style={{ borderBottom: "1px solid #dee2e6", cursor: "pointer" }} onClick={() => handleChange(row,"yes",index)}>
                {mapTable.map((key, i) => {
                  let value = getValueFromKey(row,key);
                  let totalAmount = row?.userAuthSubs ? row.userAuthSubs?.reduce((a,b)=> a + Number(b.totalAmount),0).toFixed(2) : value;
                  let paidAmount = row.userAuthSubs?.reduce(
                    (total, subscription) =>
                      total + (subscription.authSubsInstallments?.reduce(
                        (installmentTotal, installment) => installmentTotal + (installment.payAmount || 0),
                        0
                      ) || 0),
                    0
                  ).toFixed(2)
                  let totalPayment = previewIndex == 1 ? row?.authSubsInstallments?.reduce((acc, curr) => acc + Number(curr?.payAmount || 0), 0) : 0;
                  // console.log(value,key,"mapTablemapTable",tableData,mapTable,"row",row,"totalPayment",totalPayment)
                  return (
                    <td key={i} style={{ textAlign: "center", padding: "16px", fontWeight: 600, borderRight: "1px solid #dee2e6", width: key == 'clientEmail' ? "100px" : "" }}>
                      {key == 'totalAmount' ? `$${totalAmount == "-" ? '0.00' : totalAmount}` : key == 'paidAmount' ? `$${paidAmount || 0.00}` :  key == 'clientEmail' ? value.slice(0, value.length/2) + "\n" + value.slice(value.length/2) : key == "payAmount" || key == "installmentAmount" || key == "totalDiscount" ? `$${(value == null || value == '-' ? 0.00 : value) || 0.00}` : key == "totalOccurrence" && value == 9999 ? 'Annually' : key == "totalPayment" ? `$${totalPayment || 0.00}` : value }
                    </td>
                  );
                })}
                {JSON.stringify(mapTable) === JSON.stringify(table1Res) && (
                 <td style={{ textAlign: "center", padding: "16px", fontWeight: 600 }}>
                  <Button htmlType="button" style={{margin: "8px",backgroundColor: "#720c20",color: "white",borderRadius: "5px",fontWeight: "600"}} onClick={(e) => {
                    e.stopPropagation();
                    showActionModal(row);
                  }}><span className="pt-0">Report</span>
                  </Button>
                </td>)}
              </tr>
            )) : <div className="text-center">No Data</div>}
          </tbody>
        </table>
      </div>
      <Modal
        title="Report"
        visible={actionModalVisible}
        onCancel={() => {
          setActionModalVisible(false);
          setCurrentRecord(null);
        }}
        footer={null}
        enforceFocus={false}
        destroyOnClose={true}
        style={{ zIndex: 9999}}
        closeIcon={<div className='text-light'><img width="14px" src='/icons/crossIcon.svg' /></div>}
        >
        {/* <>{console.log(currentRecord, "sjkkkkk")}</> */}
        {currentRecord ? (
          <div>
            <div className="d-flex justify-content-between mt-2" style={{ marginBottom: '5px' }}>
              <p className="mb-0" style={{width:'40%'}}><strong>Client Name:</strong> {currentRecord.clientName}</p>
              <p className="mb-0" style={{width:'30%'}}><strong>Mat Number:</strong> {currentRecord.matNo || '-'}</p>
              <p className="mb-0" style={{width:'30%'}}><strong>Service Plan Name:</strong> {currentRecord.servicePlanName}</p>
            </div>
            <div className="d-flex justify-content-between" style={{ marginBottom: '5px' }}>
              <p className="mb-0 d-flex" style={{width:'40%'}}><strong>Client Email:</strong><span style={{wordBreak:'break-all'}}> {currentRecord.clientEmail}</span></p>
              <p className="mb-0" style={{width:'30%'}}><strong>Client Phone:</strong> {formatPhoneNumber(currentRecord.clientPhone)}</p>
              <p className="mb-0" style={{width:'30%'}}>
                <strong>Total Amount: </strong>
                ${currentRecord.userAuthSubs.reduce(
                  (total, subscription) => total + (subscription.totalAmount || 0),
                  0
                ).toFixed(2)}
              </p>
            </div>
            <div className="d-flex justify-content-between" style={{ marginBottom: '5px' }}>
              <p className="mb-0" style={{width:'40%'}}>
                <strong>Total Paid: </strong>
                ${currentRecord.userAuthSubs.reduce(
                  (total, subscription) =>
                    total + (subscription.authSubsInstallments?.reduce(
                      (installmentTotal, installment) => installmentTotal + (installment.payAmount || 0),
                      0
                    ) || 0),
                  0
                ).toFixed(2)}
              </p>
              <p className="mb-0" style={{width:'30%'}}><strong>Total Agreement:</strong> {currentRecord.userAuthSubs?.length || 0}</p>
              <p className="mb-0" style={{width:'30%'}}></p>
            </div>
            {currentRecord?.userAuthSubs?.map((subscription, index) => (
              <div key={index} className="mt-3" style={{padding: "10px", border: "1px solid #ccc", borderRadius: "8px" }}>
                <div className="table-wrapper mt-0 me-1 mb-1">
                      <div className="d-flex gap-5">
                        <div style={{width:'75%'}}>
                        <p className="mb-0"><strong>Agreement :</strong> {subscription.subscriptionName || 'N/A'}</p>
                        <p className="mb-0"><strong>Discount :</strong>  ${parseFloat(subscription.totalDiscount || 0).toFixed(2)}</p>
                        <p className="mb-0"><strong>Installment Amount:</strong> ${subscription.installmentAmount || 0}</p>
                        {/* <p className="mb-0"><strong>Total Paid :</strong>  ${subscription.authSubsInstallments?.reduce((total, installment) => total + (installment.payAmount || 0),0).toFixed(2) || '0.00'}</p> */}
                        {/* <p className="mb-0"><strong>Next Payment Date:</strong> {subscription.authSubsEndDate ? getFormattedDateForCE(subscription.authSubsEndDate) : 'N/A'}</p> */}
                        </div>
                        <div className="w-50">
                        <p className="mb-0"><strong>Total Amount :</strong>  ${parseFloat(subscription.totalAmount || 0).toFixed(2)}</p>
                        <p className="mb-0"><strong>Start Date:</strong> {getFormattedDateForCE(subscription.authSubsStartDate)}</p>
                        <p className="mb-0"><strong>Plan:</strong> {getTimePeriodLabel(currentSub?.authLength)}</p>
                        {/* <p className="mb-0"><strong>Installment Frequencies:</strong> {getTimePeriodLabel(subscription.authLength)}</p> */}
                        </div>
                        <div className="w-50">
                          <p className="mb-0"><strong>Total Paid :</strong>  ${subscription.authSubsInstallments?.reduce((total, installment) => total + (installment.payAmount || 0),0).toFixed(2) || '0.00'}</p>
                          <p className="mb-0"><strong>No. of Installment:</strong> {subscription?.totalOccurrence == 9999 ? 'Annually' : subscription?.totalOccurrence }</p>
                          <p className="mb-0"><strong>Status:</strong> {subscription?.isActive ? "Active" : "Not Active"}</p>
                        {/* <p><strong>Next Payment Date:</strong> {subscription.authSubsEndDate ? getFormattedDateForCE(subscription.authSubsEndDate) : 'N/A'}</p> */}
                        </div>
                      </div>
                      {subscription?.authSubsInstallments?.length > 0 && <table className="table mb-0 border border-1 mt-2" style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0, border: "1px solid #ccc" }}>
                      <thead style={{ backgroundColor: "#fff", zIndex: 1 }}>
                      <tr>
                      {headers3.map((header, index) => (
                      <th key={index} className='fw-bold p-2 text-center shadow-sm'>{header}</th>
                      ))}
                      </tr>
                      </thead>
                      <tbody>
                      {subscription?.authSubsInstallments?.filter((e)=>{return e.orderId != 0})?.map((row, index) => (
                      <tr key={index} style={{ borderBottom: "1px solid #dee2e6", cursor: "pointer" }}>
                      {table1Re3?.map((key, i) => {
                      let value = getValueFromKey(row,key);
                      return (
                      <td key={i} style={{ textAlign: "center", padding: "16px", fontWeight: 600, borderRight: "1px solid #dee2e6", width: key == 'clientEmail' ? "100px" : "" }}>
                        {key == 'payAmount' ? `$${value}` : key == 'Status' ? 'Paid' : value}
                      </td>
                      );
                      })}
                      </tr>
                      ))}
                      </tbody>
                      </table>}
                </div>
              </div>
            ))}
            <Button className="mt-3" onClick={() => setActionModalVisible(false)}>Close</Button>
          </div>
        ) : (
          <p>No record selected.</p>
        )}
      </Modal>
    </div>
  );
};

export default CommonTable;

